import { Session } from '@benzinga/session';
import { ListenableSubscribable } from '@benzinga/subscribable';
import { SafeError, SafePromise, SafeType } from '@benzinga/safe-await';
import { InvestorsRestful } from './restful';
import { InvestorsResponse, NasdaqPrivateMarketListResponse, NasdaqPrivateMarketPricingResponse } from './entities';

interface InvestorsEvent {
  error: SafeError;
  type: 'investors:error';
}

export class InvestorsRequest extends ListenableSubscribable<InvestorsEvent> {
  private restful: InvestorsRestful;

  constructor(session: Session) {
    super();
    this.restful = new InvestorsRestful(session);
  }

  public getCompanies = (symbol: string): SafePromise<NasdaqPrivateMarketListResponse> => {
    return this.run(() => this.restful.getCompanies(symbol));
  };

  public getFunding = (symbol: string): SafePromise<NasdaqPrivateMarketListResponse> => {
    return this.run(() => this.restful.getFunding(symbol));
  };

  public getInvestors = (symbol: string): SafePromise<InvestorsResponse> => {
    return this.run(() => this.restful.getInvestors(symbol));
  };

  public getManagement = (symbol: string): SafePromise<NasdaqPrivateMarketListResponse> => {
    return this.run(() => this.restful.getManagement(symbol));
  };

  public getPricing = (symbol: string): SafePromise<NasdaqPrivateMarketPricingResponse> => {
    return this.run(() => this.restful.getPricing(symbol));
  };

  private run = async <T>(fn: () => SafePromise<T>): SafePromise<T> => {
    try {
      const response = (await fn()) as SafeType<T>;
      if (response.err) {
        return { err: response.err };
      }
      return response;
    } catch (err: unknown) {
      return { err: err as SafeError };
    }
  };
}
